import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

type OutlineProps = {
  activeColor: string
  hasActiveOutline?: boolean
  outlineColor?: string
  roundness?: number
  label?: boolean
}

const Outline = ({
  label,
  activeColor,
  hasActiveOutline,
  outlineColor,
  roundness,
}: OutlineProps) => {
  return (
    <View
      pointerEvents="none"
      style={[
        styles.outline(
          hasActiveOutline ?? false,
          roundness ?? 0,
          activeColor,
          outlineColor ?? 'transparent'
        ),
        !label && styles.noLabelOutline,
      ]}
      testID="text-input-outline"
    />
  )
}

const styles = StyleSheet.create(() => ({
  noLabelOutline: {
    top: 0,
  },
  outline: (
    hasActiveOutline: boolean,
    roundness: number,
    activeColor: string,
    outlineColor: string
  ) => ({
    borderColor: hasActiveOutline ? activeColor : outlineColor,
    borderRadius: roundness,
    borderWidth: hasActiveOutline ? 2 : 1,
    bottom: 0,
    left: 0,
    position: 'absolute' as const,
    right: 0,
    top: 6,
  }),
}))

export default Outline
